import * as ko from "knockout";
import { labelsService } from "services";

class labels {
  labels: KnockoutObservable<any>;

  constructor() {
    this.labels = ko.observable({});
    ko.bindingHandlers.label = {
      init: (element, valueAccessor, allBindings, viewModel, bindingContext) => {
        var label = valueAccessor();
        $(element).text(this.descrComputed(label)());
      },
      update: (element, valueAccessor, allBindings, viewModel, bindingContext) => {
        // This will be called once when the binding is first applied to an element,
        // and again whenever any observables/computeds that are accessed change
        // Update the DOM element based on the supplied values here.
        var label = valueAccessor();
        $(element).text(this.descrComputed(label)());
      },
    };

    ko.bindingHandlers.placeholder = {
      init: (element, valueAccessor, allBindings, viewModel, bindingContext) => {
        var label = valueAccessor();
        $(element).attr("placeholder", this.descrComputed(label)());
      },
      update: (element, valueAccessor, allBindings, viewModel, bindingContext) => {
        // This will be called once when the binding is first applied to an element,
        // and again whenever any observables/computeds that are accessed change
        // Update the DOM element based on the supplied values here.
        var label = valueAccessor();
        $(element).attr("placeholder", this.descrComputed(label)());
      },
    };
  }
  descrComputed = (message_id: string | KnockoutObservable<string>) => {
    return ko.computed(() => {
      const labelToTranslate = ko.unwrap(message_id);

      if (!this.labels() || !labelToTranslate) {
        return labelToTranslate;
      }

      let tranlatedLabel = this.labels()[labelToTranslate];
      if (!tranlatedLabel) {
        return labelToTranslate;
      }

      return tranlatedLabel;
    });
  };

  descr = (message_id: string) => {
    const labelToTranslate = ko.unwrap(message_id);
    if (!this.labels() || !labelToTranslate) {
      return labelToTranslate;
    }

    let tranlatedLabel = this.labels()[labelToTranslate];
    if (!tranlatedLabel) {
      return labelToTranslate;
    }

    return tranlatedLabel;
  };

  descrWithParams = (message_id: string, params: any[]) => {
    const labelToTranslate = ko.unwrap(message_id);
    if (!this.labels() || !labelToTranslate) {
      return labelToTranslate;
    }

    let translatedLabel = this.labels()[labelToTranslate];
    if (!translatedLabel) {
      return labelToTranslate;
    }

    // Replace placeholders in the translated label with actual parameter values
    params.forEach((param, index) => {
      translatedLabel = translatedLabel.replace(`{${index}}`, param);
    });

    return translatedLabel;
  };

  update = async (locale_code: string = null) => {
    let locale = "EN-US";
    if (!locale_code) {
      locale = localStorage.getItem("UserLocaleCode");
    } else {
      localStorage.setItem("UserLocaleCode", locale_code);
      locale = locale_code;
    }
    const labels = await labelsService.getLabels(locale);
    this.labels(labels);
  };
}
export default new labels();
